const moneyFormatterWithoutDecimals = new Intl.NumberFormat('es-AR', {
  style: 'currency',
  currency: 'ARS',
  minimumFractionDigits: 0,
});

export default moneyFormatterWithoutDecimals;
